<template>
  <div class="data-list">
    <div class="head-box">
      <el-tabs class="tabs" ref="myTabs" v-model="activeName" v-if="isShowTab" :key="activeName">
        <!-- <el-tab-pane label="资金数据核对" name="capitalData"></el-tab-pane> -->
        <el-tab-pane label="活动数据核对" name="activityData"></el-tab-pane>
        <el-tab-pane label="经销商钱包核对" name="dealerData"></el-tab-pane>
        <el-tab-pane label="银联订单核对" name="unionpayOrder"></el-tab-pane>
        <el-tab-pane label="银联财务核对订单" name="financialDataOrder"></el-tab-pane>
      </el-tabs>
    </div>
    <component :is="activeName" :ref="activeName"></component>
  </div>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import capitalData from "./components/capital-data";
import activityData from "./components/activity-data";
import dealerData from "./components/dealer-data";
import unionpayOrder from './components/unionpayOrder';
import financialDataOrder from './components/financial-data-order'
export default {
  name: "checkData",
  mixins: [pagePathMixin],
  components: {
    capitalData,
    activityData,
    dealerData,
    unionpayOrder,
    financialDataOrder
  },
  data() {
    return {
      activeName: "activityData",
      isShowTab: true
    };
  },
  watch: {
    $route: {
      handler(val, olv) {
        let params = val.params;
        if (
          (olv.path == "/dataReport/activity-data-details" || "/dataReport/dealer-data-details") &&
          JSON.stringify(params) != "{}" &&
          params.active &&
          params.active != this.activeName
        ) {
          this.activeName = params.active;
          this.isShowTab = false
          setTimeout(() => {
            this.isShowTab = true
            this.$refs[this.activeName].tabHeightSum()
          }, 500);
        }
      },
    },
  },
  mounted() {
    this.activeName = this.$route.params.active || "activityData";
  },
  methods: {
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .head-box {
    margin: 0 15px;
    margin-top: 5px;
    padding: 10px;
    padding-bottom: 0px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background: #fff;
  }
}
</style>
